import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type DeletePostRouteParameters = {
  id: string;
};

export const deletePost = async ({ routeParams: { id } }: RouteParamsRequest<DeletePostRouteParameters>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.posts.delete(id));
